export const LANGUAGE_COOKIE = '_cgloc';
export const LANGUAGE_COOKIE_DOMAIN = '.chaos.com';
export const LANGUAGE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year, in seconds
export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português (Brasil)' },
  { code: 'cn', label: '简体中文' },
  { code: 'kr', label: '한국어' },
  { code: 'jp', label: '日本語' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const isLanguageCode = (
  value: string | undefined,
): value is LanguageCode =>
  LANGUAGES.some((language) => language.code === value);

/** For building the route path's `:language(en|es|pt|cn|kr|jp|de|fr|it)` constraint. */
export const LANGUAGE_PATH_PATTERN = LANGUAGES.map((l) => l.code).join('|');
